var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgExplore = function SvgExplore(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 113,
    viewBox: "0 0 116 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "illustration-background-fill",
    d: "M46.5 0C71.077 0 91 19.7 91 44S71.077 88 46.5 88 2 68.3 2 44 21.923 0 46.5 0Z",
    fill: "#F6F7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "illustration-main-fill",
    d: "M30.643 19.143H18.857V7.357a2.357 2.357 0 0 0-4.714 0v11.786H2.357a2.358 2.358 0 0 0 0 4.714h11.786v11.786a2.358 2.358 0 0 0 4.714 0V23.857h11.786a2.358 2.358 0 0 0 0-4.714Z",
    fill: "#008C73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "illustration-light-stroke",
    d: "M48.501 65.75c0-11.168 9.083-20.25 20.25-20.25 11.165 0 20.25 9.082 20.25 20.25S79.916 86 68.751 86c-11.168 0-20.25-9.082-20.25-20.25Zm59.755 34.739L90.058 82.29c3.554-4.57 5.693-10.3 5.693-16.54 0-14.911-12.089-27-27-27-14.914 0-27 12.089-27 27 0 14.91 12.086 27 27 27 6.237 0 11.965-2.137 16.531-5.687l18.201 18.198a3.384 3.384 0 0 0 4.773 0 3.383 3.383 0 0 0 0-4.772Z",
    fill: "#B2BBC0"
  })));
};

export default SvgExplore;